import React from "react";
import ReactDOM from "react-dom/client";
import "./utils/i18n";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ModuleRegistry, AllCommunityModule } from "ag-grid-community";
import { client_selected } from "./client";

ModuleRegistry.registerModules([AllCommunityModule]);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const configureDocument = () => {
  // PUBLIC_URL pode ser string vazia em dev ou caminho base em produção
  // Se for o literal "%PUBLIC_URL%", substituir por string vazia
  let publicUrl = process.env.PUBLIC_URL || "";
  if (publicUrl === "%PUBLIC_URL%") {
    publicUrl = "";
  }

  const timestamp = new Date().getTime();

  // Usar valores do client_selected com fallback para name caso title não exista
  const title = client_selected.title || "SpiderTrader";
  const favicon = client_selected.favicon || "favicon-spidertrader.ico";
  const description =
    client_selected.description ||
    `SpiderTrader - Plataforma de trading e gestão de investimentos.`;

  // Configurar favicon - usar caminho relativo começando com /
  const faviconLink = document.querySelector(
    "link[rel='icon']"
  ) as HTMLLinkElement | null;
  if (faviconLink) {
    // Se publicUrl estiver vazio, usar caminho relativo; caso contrário, usar publicUrl
    const faviconPath = publicUrl
      ? `${publicUrl}/${favicon}?ts=${timestamp}`
      : `/${favicon}?ts=${timestamp}`;
    faviconLink.href = faviconPath;
  }

  // Configurar título
  document.title = title;

  // Configurar meta description
  let metaDescription = document.querySelector(
    "meta[name='description']"
  ) as HTMLMetaElement | null;
  if (!metaDescription) {
    metaDescription = document.createElement("meta");
    metaDescription.name = "description";
    document.head.appendChild(metaDescription);
  }
  metaDescription.content = description;
};

configureDocument();
root.render(
  // <React.StrictMode>
  <App />
  // </React.StrictMode>
);

reportWebVitals();
